import { ReactElement } from 'react';
import { SpinnerContainer } from 'src/components/SpinnerContainer';
import styles from './ProductDetailsTab.module.scss';
import ProductTypePanel from '../ProductTypePanel';
import ProductDetailsPanel from '../ProductDetailsPanel';
import TaxRatePanel from '../TaxRatePanel';
import ProductImagePanel from '../ProductImagePanel';
import { IMenuItem } from 'src/types/menu.types';
import { useItem } from 'src/hooks/useItem/useItem';
import { useExternalSystems } from 'src/hooks/useExternalSystems/useExternalSystems';
import { Spinner } from '@weareopenr/component-library';
import { ProductCategoriesPanel } from '../ProductCategoriesPanel';

export interface ProductDetailsTabParams {
  itemId: IMenuItem['itemId'];
}

const ProductDetailsTab = ({ itemId }: ProductDetailsTabParams): ReactElement => {
  const { data: item, isLoading } = useItem(itemId);
  const { data: externalSystems } = useExternalSystems();

  return isLoading ? (
    <SpinnerContainer data-testid="loadingIcon">
      <Spinner size="xlarge" colour="rainbow" />
    </SpinnerContainer>
  ) : (
    <div className={styles['container']}>
      <div>
        <ProductTypePanel currentItem={item} />
        <ProductDetailsPanel item={item} aggregators={externalSystems} />
      </div>
      <div>
        <ProductImagePanel currentItem={item} />
        <TaxRatePanel item={item} aggregators={externalSystems} />
        <ProductCategoriesPanel item={item} />
      </div>
    </div>
  );
};

export default ProductDetailsTab;
